"use client";
import Image from "next/image";

export default function AboutTheProgram({ course }) {
  const AboutTheProgramContent = course?.AboutTheProgram?.[0];

  return (
    <section className="page-container xl:px-[110px] pt-[50px] pb-[50px] mb:pb-[80px] xl:pb-[100px] xl:pt-[100px] bg-white program-overview-section">
      <div>
        {/* Header with decorative line */}
        <div className="mb-8">
          <div className="flex items-center gap-[39px]  mb-[12px] xl:mb-[18px]">
            <h2 className="text-black">About The Programme</h2>
          </div>
          {AboutTheProgramContent.FirstDescription && (
            <p className="text-black w-full xl:w-[80%]  leading-[28px] mb-[20px] xl:mb-[24px]">
              {AboutTheProgramContent.FirstDescription}
            </p>
          )}

          {AboutTheProgramContent.SecondDescription && (
            <p className="text-black w-full xl:w-[80%] leading-[28px] mb-[46px]">
              {AboutTheProgramContent.SecondDescription}
            </p>
          )}
        </div>

        {/* Content Grid */}
        <div className="grid md:grid-cols-2 xl:gap-[12px] items-start">
          {/* Left - Text Content */}
          <div className="program-overview-content bg-[#FFA201] px-[16px] py-[38px] md:px-[32px] xl:px-[40px] xl:pt-[70px] pb-14 h-full">
            <h2 className="mb-[12px]">Our Offering</h2>
            {AboutTheProgramContent.WhatAreWeOfferingContent && (
              <p className="pb-[36px] xl:pb-[65px]">
                {AboutTheProgramContent.WhatAreWeOfferingContent}
              </p>
            )}
            <h4 className="pb-[20px] md:pb-[24px] text-[20px] md:text-[30px]" style={{fontFamily:"saans-bold"}}>Key Areas of Learning:</h4>
            {AboutTheProgramContent.Hightlights?.[0]?.children && (
              <div className="flex flex-wrap gap-[6px] md:gap-[8px] xl:gap-y-[10px]">
                {AboutTheProgramContent.Hightlights[0].children.map(
                  (item, index) => {
                    // Safely extract the text from the nested structure
                    const highlightText = item.children?.[0]?.text;

                    if (!highlightText) {
                      return null; // Skip if text is missing
                    }

                    return (
                      <div
                        key={index}
                        // Styling to match the dark, rounded tags in the image
                        className="bg-[#011F31] text-white px-[20px] py-[13px] md:px-[26px] md:py-[15px] rounded-full font-medium text-[16px]"
                      >
                        {/* Remove " and more" from the end of the last item's text */}
                        {highlightText
                          .trim()
                          .replace(/ and more$/, "")
                          .trim()}
                      </div>
                    );
                  }
                )}
              </div>
            )}
          </div>

          {/* Right - Image */}
          {course.AboutTheProgramImage && (
            <div className="relative h-full">
              <Image
                src={
                  course.AboutTheProgramImage.formats?.large?.url ||
                  course.AboutTheProgramImage.url
                }
                alt={
                  course.AboutTheProgramImage.alternativeText ||
                  "Programme Overview"
                }
                width={680}
                height={369}
                className="w-full h-full object-cover"
                sizes="(max-width: 768px) 100vw, 680px"
                unoptimized
              />
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
